import React from 'react';
import Icon from '../../../generic-components/Icon';
import removeIcon from '../../../assets/svg/remove-link.svg';
import Heading from '../../../generic-components/Heading';

import { STYLE } from '../constants';

const { PAGES: { POST_LINKED } } = STYLE;

interface IProps {
  isEdit: boolean;
  title: string;
  content: string;
  idx: number;
  isSelected: boolean;
  isLastOption: boolean;
  removeLinkItem: (idx: number) => void;
  onClick: (idx: number) => void;
}

export const LinkItem = ({
  isEdit, title, content, idx, removeLinkItem, onClick, isSelected, isLastOption,
}: IProps) => {
  const handleRemoveOption = () => {
    removeLinkItem(idx);
  };

  const handleClick = () => {
    onClick(idx);
  };

  return (
    <div
      tabIndex={0}
      role='button'
      onKeyDown={() => {}}
      onClick={handleClick}
      className={`${isSelected ? POST_LINKED.LINK_ITEM.WRAPPER_SELECTED : ''} 
    ${isLastOption ? '' : POST_LINKED.LINK_ITEM.WRAPPER_BORDER_BOTTOM} ${POST_LINKED.LINK_ITEM.WRAPPER_BASE}`}
    >
      { isEdit && <Icon onClick={handleRemoveOption} className={POST_LINKED.LINK_ITEM.REMOVE_ICON} src={removeIcon} />}
      <div className={POST_LINKED.LINK_ITEM.CONTENT_WRAPPER}>
        <Heading title={title} className={POST_LINKED.LINK_ITEM.HEADING} />
        <p className={POST_LINKED.LINK_ITEM.CONTENT}>{content}</p>
      </div>
    </div>
  );
};
